module.exports = __webpack_public_path__ + "img/f0ed2e674ee5252ca917a37bb3336305.png";